import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid/v1';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Divider,
	Button,
	Grid,
	TextField,
	Checkbox,
	Autocomplete
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { RANDumpExportForm } from './components';
import { RANDumpExport, SetFormState } from '../actions/RANDumpExportActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const DumpExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const sites = useSelector(state => state.reportsReducer.sites);
	const selectedSites = useSelector(
		state => state.reportsReducer.selectedSites
	);
	const lastUpdate = useSelector(state => state.reportsReducer.lastUpdate);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.RANDumpExportReducer.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				site: '',
				startDate: null,
				endDate: null,
				reportType: '',
				reportTech: ''
			},
			touched: {
				...formState.touched,
				site: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Acceptance Tools">
			<Header module="Acceptance Tools" view="Dumps Export" />
			<RANDumpExportForm />
		</Page>
	);
};

export default DumpExport;
